/* eslint-disable no-unused-vars */
import React from 'react';
import { Helmet } from 'react-helmet';
import Auth from '../../api/auth';
import ScriptLoader from '../ScriptLoader/ScriptLoader';
import { connect } from 'react-redux';
import ChatFrame from './ChatFrame';
import ChatButton from './ChatButton';


const ChatBot = ({
    config: {
        ChatBot_ScriptUrl,
        ChatBot_insyncAppId,
        ChatBot_insyncEnv,
        ChatBot_IsEnabled,
    },
    user,
}) => {
    // console.log('Chat Bot initialize');

    var isChatBotEnabled = ChatBot_IsEnabled && ChatBot_IsEnabled.toLowerCase() === 'true';
    if (!isChatBotEnabled || !ChatBot_ScriptUrl || !user?.userId) {
        // console.error('Chat Bot script URL is required');
        return null;
    }
    const insyncOnLoad = () => {
        const authData = Auth.getAuthData();
        const insyncChatbotConfig = {
            // <!-- Mandatory Fields  -->
            insyncMarket: 'us_timepayment',
            insyncEnv: ChatBot_insyncEnv,
            insyncAppIdDev: '702c1e15c41a13c70bd2b181f6a98cc1', // do not remove
            insyncAppIdStage: '478b2581c1863bac4fab00cf95a39309', // SF uses it such way
            insyncAppIdProd: '23ee3aaed2b560eb49b4608b6937181a', // all 3 should be here
            insyncUserIdExpiryInDays: 3,
            insyncUserId: user.userId,

            // <!-- Optional: Pass any other reference if needed -->
            insyncContextParams: {
                brandUserSessionToken: authData.token,
                user: {
                    id: user.userId,
                    email: user.unique_name,
                },
                // userId: user.userId
                //    any-other-reference: "<pass any-other-reference: if needed>",
            },

            // <!-- Optional: Assign this insyncChatIconId to the chat button/icon in Step2 if you want to use the show/hide button functionality  -->
            insyncChatIconId: 'insync-chat-icon-id',

            // <!-- Mandatory: Assign this id to the iframe hosting chatbot  -->
            insyncIframeId: 'insync-iframe',
            insyncTriggerPoint: 'Timepayment',

            // <!-- Optional: Specify your font css here in case want to override the css  -->
            insyncCustomCssSrc: '',
        };
        // logToServer.debug('ChatBot init with config:' + JSON.stringify(insyncChatbotConfig));
        //console.log(`%cChatBot init:`, 'color: #007acc;', JSON.stringify(insyncChatbotConfig));
        window.insyncSetChatEnv(insyncChatbotConfig);
    };

    return (
        <>
            <Helmet>
                <link rel="stylesheet" href="https://dbrd449anfbv4.cloudfront.net/insync_chat_button.css"></link>
            </Helmet>
            <ScriptLoader src={ChatBot_ScriptUrl} onLoad={insyncOnLoad} />
            <ChatFrame></ChatFrame>
            <ChatButton></ChatButton>
        </>
    );
};

export default connect((state) => {
    var reduxState = { config: state?.app?.config, user: state?.login?.CurrentUser };
    return reduxState;
})(ChatBot);
